const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';
const API_PATH = `${API_BASE_URL}/users`;
const getAuthToken = () => {
  return localStorage.getItem('token');
};

export const getUsers = async () => {
  try {
    const response = await fetch(API_PATH, {
      headers: {
        'Authorization': `Bearer ${getAuthToken()}`
      }
    });
    
    return await response.json();
  } catch (error) {
    console.error('Get users error:', error);
    throw error;
  }
};

export const createUser = async (username, password, role = 'member') => {
  try {
    const response = await fetch(API_PATH, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getAuthToken()}`
      },
      body: JSON.stringify({ username, password, role })
    });
    
    return await response.json();
  } catch (error) {
    console.error('Create user error:', error);
    throw error;
  }
};

export const deleteUser = async (userId) => {
  try {
    const response = await fetch(`${API_PATH}/${userId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${getAuthToken()}`
      }
    });
    
    return await response.json();
  } catch (error) {
    console.error('Delete user error:', error);
    throw error;
  }
};
